var angular = require('angular');
var template = require('./template.pug');
var _ = require('underscore')

 angular.module("app.directives").directive('ngDualListBox', function () {
  return {
    restrict: 'E',
    scope: {
      leftTitle: "@",
      leftDescription: "@",
      leftList: "=",
      rightTitle: "@",
      rightDescription: "@",
      rightList: "=",
      type: "@",
      filter: "=",
    },
    template: template,
    link: function (scope, element, attrs) {
      // scope.moveToLeft = moveToLeft;
      scope.collapse = collapse;
      scope.expand = expand;
      scope.add = add;

      scope.parenthashTable = {};
      scope.leftCount = 0;

      scope.onChange = function(){
        attrs.onChange && scope.$parent.$eval(attrs.onChange, scope.$parent);
      }

      scope.$watchCollection('leftList', function (newValue, oldvalue) {
        scope.parenthashTable = {};
        if (!newValue || !newValue.length) {
          scope.count();
          return;
        }
        var item = newValue[0];
        recursiveBuildHashtable(item);
        hideItems();
        scope.count();
      });

      scope.$watchCollection('rightList', function (newValue, oldvalue) {
        hideItems();
        scope.count();
      });

      scope.count = function(){
        var keys = Object.keys(scope.parenthashTable);
        var count = keys.length;
        var selected = keys.filter(function(i){
          var item = scope.parenthashTable[i];
          return !item.hide
        }).length;
        var hidden = selected !== count;

        scope.leftCount = count + ' item' + (count !== 1 && 's');
        if (hidden) scope.leftCount += ' (some selected)';
      }

      function hideItems(){
        var list = scope.rightList || [];
        list.forEach(function(item){
          var left = scope.parenthashTable[item.id];
          if (!left) return;
          left.hide = true;
        })
      }


      function recursiveBuildHashtable(item) {
        if (!item) return;

        scope.parenthashTable[item.id] = item;

        if (item.nodes && item.nodes.length) {
          if (scope.filter && scope.type == 'CharitableCategories'){
            item.expanded = true;
          } else if (scope.type == 'CharitableCategories'){
            item.expanded = !item.parentId;
          } else{
            item.expanded = true;
          }
          item.nodes.forEach(recursiveBuildHashtable)
        }
      }

      scope.remove = function (item) {
        var index = scope.rightList.indexOf(item);
        scope.rightList.splice(index, 1);
        unhideLeftListNodes([item]);
        scope.onChange();
        scope.count();
      }

      // function moveToLeft() {
      //   var movedNodes = [];
      //   // scope.selectedRightList.forEach(function (item) {
      //   //   var node = scope.parenthashTable[item.id];
      //   //   if (node) {
      //   //     node.hide = false;
      //   //     movedNodes.push(node);
      //   //   }
      //   // });
      //   for (var i = 0; i < scope.selectedRightList.length; i++) {
      //     var id = scope.selectedRightList[i].id;
      //     for (var j = 0; j < scope.rightList.length; j++) {
      //       var index = scope.rightList.indexOf(scope.selectedRightList[i]);
      //       if (scope.rightList[j].id == id)
      //         scope.rightList.splice(j, 1);
      //     }
      //   }
      //   scope.selectedRightList = [];
      //   unhideLeftListNodes(movedNodes);
      // }

      function unhideLeftListNodes(list) {
        if (list) {
          for (var i = 0; i < list.length; i++) {
            var item = list[i];

            var leftListItem = scope.parenthashTable[item.id];
            if (leftListItem) {
              leftListItem.hide = false;

              recursivelyUnHideParents(leftListItem.parentId);
              recursivelyUnHideChildren(leftListItem);
            }
          }
        }
      }

      function recursivelyUnHideParents(parentId) {
        if (!parentId) return;

        var item = scope.parenthashTable[parentId];
        if (!item || item.hide == false) return;

        item.hide = false;
        recursivelyUnHideParents(item.parentId);
      }

      function recursivelyUnHideChildren(parent) {
        if (!parent || !parent.nodes) return;

        parent.nodes.forEach(function (child) {

          //there is a bug in that you can move parents from higher levels across and it will not remove its child.  this causes the remove to show it in error.

          child.hide = false;
          recursivelyUnHideChildren(child);
        })
      }

      function getChildIds(parent, ids) {
        if (!parent || !parent.nodes) return;
        parent.nodes.forEach(function (child) {
          ids.push(child.id)
          getChildIds(child, ids);
        })
        return ids;
      }

      function add(data, parent) {
        //ancestry found searches tree for existing parents to decide whether to move item across
        if (!ancestryFound(data)) {
          if (!scope.disableItemHiding)
            data.hide = true;//here
          scope.rightList.push({ name: data.name, displayName: data.displayName, id: data.id, parent: parent.name, parentId: data.parentId, rootId: data.rootId, root: data.root });
          validateDisplay(data);
          scope.onChange();
          scope.count();
        }
      }

      //calls ancestor search function to provide a list of related ids
      function ancestryFound(data) {
        var listedAncestorsFound = false;
        if (scope.findAllAncestorsFn) {
          var ancestors = scope.findAllAncestorsFn({ itemId: data.id });
          if (ancestors) {
            ancestors.forEach(function (element) {
              if (listedAncestorsFound == false) {
                var foundObject = _.find(scope.rightList, function (obj) { if (obj.id == element) return obj; });
                if (foundObject)
                  listedAncestorsFound = true;
              }
            })

          }

        }
        return listedAncestorsFound;

      }

      function collapse(data) {
        data.expanded = false;
      }

      function expand(data) {
        data.expanded = true;
      }

      function validateDisplay(itemToValidate) {
        //recurse through tree to find new entry
        var ids = [];
        if (scope.fullTree) {
          var foundItem = findInFullTree(itemToValidate.id);
          if (foundItem) {
            itemToValidate = foundItem;
          }
        }
        var childIds = getChildIds(itemToValidate, ids);
        if (childIds && childIds.length > 0) {
          var itemsToRemove = [];
          for (var i = 0; i < scope.rightList.length; i++) {
            childIds.forEach(function (item) {
              if (scope.rightList[i].id == item) {
                itemsToRemove.push(scope.rightList[i]);
              }
            });
          }
          for (var i = 0; i < itemsToRemove.length; i++) {
            var index = scope.rightList.indexOf(itemsToRemove[i])
            scope.rightList.splice(index, 1);
          }
        }
      }

      function findInFullTree(id) {
        return findById(scope.fullTree[0], id);
      }

      function findById(node, id) {
        if (node == null) return null;
        if (node.id == id) return node;
        if (node.nodes === undefined) return null;
        if (node.nodes.length < 1) return null;
        for (var i = 0; i < node.nodes.length; i++) {
          var resultNode = findById(node.nodes[i], id);
          if (resultNode) return resultNode;
        }
        return null;
      }

      function validateTree(name) {
        recursiveUnHideChild(scope.leftList, name);
      }
    }
  }
});
